import React from "react";
import { Footer } from "@emnos-legacy/portal-assets";

function EmnosFooter() {
    return <Footer />;
}

export default EmnosFooter;
